import { render } from "./VueLazyYoutubeVideo.vue?vue&type=template&id=f17e215c"
import script from "./VueLazyYoutubeVideo.vue?vue&type=script&lang=js"
export * from "./VueLazyYoutubeVideo.vue?vue&type=script&lang=js"

import "./VueLazyYoutubeVideo.vue?vue&type=style&index=0&id=f17e215c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VueLazyYoutubeVideo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f17e215c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f17e215c', __exports__)) {
    api.reload('f17e215c', __exports__)
  }
  
  module.hot.accept("./VueLazyYoutubeVideo.vue?vue&type=template&id=f17e215c", () => {
    api.rerender('f17e215c', render)
  })

}


export default __exports__